import React from 'react';
import {
  ShortcutData,
  useGetCustomViewsQuery,
  useSetCustomViewsMutation,
} from '../../../../../API/pcDashboard/CustomViewsApi';
import { Form, Formik } from 'formik';
import { checkForMutationSuccess } from '../../../../../API/checkForMutationSuccess';
import { Flex } from '@zillow/constellation';
import { NameField } from '../create/customViewFields/NameField';
import { KeyboardKeyField } from '../create/customViewFields/KeyboardKeyField';
import { UrlSearchStringField } from '../create/customViewFields/UrlSearchStringField';
import { DescriptionField } from '../create/customViewFields/DescriptionField';
import { useCustomViewsContext } from '../context/CustomViewsContext';
import { DeleteCustomView } from './DeleteCustomView';
import { useGenerateCustomViewValidation } from '../create/useGenerateCustomViewValidation';
import { CustomViewsStateAndFormikContextConduit } from '../context/CustomViewsState';

export const UpdateCustomViewForm: React.FC<{ customView: ShortcutData }> = ({ customView }) => {
  const { data = {} } = useGetCustomViewsQuery();
  const [setCustomViews] = useSetCustomViewsMutation();
  const { resetContext } = useCustomViewsContext();
  const validationSchema = useGenerateCustomViewValidation(customView.id);

  return (
    <Formik
      initialValues={{
        name: customView.name ?? '',
        keyboardKey: customView.keyboardKey ?? '',
        search: customView.search ?? '',
        description: customView.description ?? '',
      }}
      validationSchema={validationSchema}
      onSubmit={async (formValues) => {
        const { [customView.id]: _, ...rest } = data;
        const response = await setCustomViews({
          ...rest,
          [customView.id]: {
            id: customView.id,
            name: formValues.name,
            keyboardKey: formValues.keyboardKey,
            search: formValues.search,
            description: formValues.description,
          },
        });
        if (checkForMutationSuccess(response, 'updating custom view')) {
          resetContext();
        }
      }}
    >
      <Form id={'update-custom-view-form'}>
        <Flex display={'flex'} flexDirection={'column'} gap={'xs'}>
          <CustomViewsStateAndFormikContextConduit />
          <NameField />
          <KeyboardKeyField />
          <UrlSearchStringField />
          <DescriptionField />
          <DeleteCustomView id={customView.id} />
        </Flex>
      </Form>
    </Formik>
  );
};
